import { pushNotificationAction } from 'actions/app-actions';

const useNotification = dispatch => {
  const showNotification = payload => {
    dispatch(pushNotificationAction(payload));
  };

  return {
    showNotification,
  };
};

export default useNotification;
